import React from 'react';
import { IconProps } from './IconTypes';

const STAR_COUNT = 12;
const RING_RADIUS = 33;
const STAR_OUTER = 11;
const STAR_INNER = 4.4;

const starPath = (cx: number, cy: number) => {
  const verticesPerStar = 10;
  let d = "";
  for (let j = 0; j < verticesPerStar; j++) {
    const a = (j * 36 - 90) * Math.PI / 180;
    const r = j % 2 === 0 ? STAR_OUTER : STAR_INNER;
    const x = cx + r * Math.cos(a);
    const y = cy + r * Math.sin(a);
    d += (j === 0 ? "M" : "L") + x.toFixed(2) + "," + y.toFixed(2) + " ";
  }
  return d + "Z";
};

const ringStarIndices = Array.from({ length: STAR_COUNT }, (_, i) => i);

const EULogo: React.FC<IconProps> = ({
  size = 16,
  color = "currentColor",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {ringStarIndices.map(i => {
        const angle = (i * (360 / STAR_COUNT) - 90) * Math.PI / 180;
        const cx = 50 + RING_RADIUS * Math.cos(angle);
        const cy = 50 + RING_RADIUS * Math.sin(angle);
        return <path key={i} d={starPath(cx, cy)} />;
      })}
    </svg>
  );
};

export default EULogo;
